module.exports = __webpack_public_path__ + "e10.no2.2f27472b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e10.no2.jpg
// module id = 3Q+r
// module chunks = 0